/* eslint-disable react/self-closing-comp */
/* eslint-disable react/no-array-index-key */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-curly-newline */
import React, { createRef } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import {
  HOT_TOURS,
  HOT_TELEG,
  SUBSCRIBE,
  HOT_FROM,
  HOT_COUNTRY,
  HOT_FLIGHT,
  HOT_PERIOD,
  HOT_SEARCH_TOUR,
  HOT_5_STAR,
  HOT_AI,
  HOT_USD,
  ALL,
  HOT_FLIGHT_ANY,
  HOT_FLIGHT_CHARTER,
  HOT_PERIOD_3D,
  HOT_PERIOD_1W,
  HOT_PERIOD_1M,
  HOT_PERIOD_ANY,
  TOURS_NOT_FOUND,
  HOT_FROM_TITLE,
} from '../../Utils/Constants/GlobalConstants';
import { ReactComponent as Fire } from '../../images/fire.svg';
import { ReactComponent as Telegram } from '../../images/logos_telegram.svg';
import { ReactComponent as Arrow } from '../../images/arrow-bottom-black-r.svg';
import { CITY_OPTIONS } from '../../Utils/Constants/CitiesFrom';
import { countries } from '../../Utils/Constants/countries';
import './css/Hot.css';
import { initalDepartureCity } from '../../Utils/Constants/InitialStateUtils';
import { getHots } from '../../Utils/RestUtils';
import HotsItem from '../HotsItem/HotsItem';
import HotLoader from '../HotsItem/HotLoader/HotLoader';
import NoResults from '../../images/no-results.png';
import { HOT_TITLE, HOT_DESCRIPTION } from '../../Utils/Constants/SEO';
import { getCurrentYear } from '../../Utils/DateUtil';

class Hot extends React.Component {
  constructor(props) {
    super(props);

    const allCountries = { id: 0, name: ALL };

    this.state = {
      cityFrom: initalDepartureCity,
      cityFromVisible: false,
      to: allCountries,
      toVisible: false,
      flightVisible: false,
      selectedFlight: { id: 1, name: HOT_FLIGHT_CHARTER },
      periodVisible: false,
      countryOpetions: [allCountries].concat(countries),
      selectedDays: { days: 21, name: HOT_PERIOD_ANY },
      starsSelected: false,
      aiSelected: false,
      usdSelected: false,
      hots: [],
      hots3: [],
      isLoading: true,
      fromText: initalDepartureCity.nameFrom,
    };

    this.fromRef = createRef();
    this.toRef = createRef();
    this.periodRef = createRef();
    this.flightRef = createRef();

    this.fromTRef = createRef();
    this.toTRef = createRef();
    this.periodTRef = createRef();
    this.flightTRef = createRef();

    this.hotsSection = createRef();
  }

  componentDidMount() {
    this.retrieveHots();
  }

  renderHotsLoaderLines = (count) => {
    const result = [];
    for (let i = 0; i < 2; i++) {
      result.push(
        <div key={`hots-${i}`} className="hot_line_w">
          {this.renderHotsLoaderLinesItems(count)}
        </div>,
      );
    }

    return result;
  };

  renderHotsLoaderLinesItems = (count) => {
    const result = [];
    for (let j = 0; j < count; j++) {
      result.push(
        <div key={`hots-item-${j}`} className="hot_item">
          <HotLoader />
        </div>,
      );
    }

    return result;
  };

  getSearchPayload = () => {
    const {
      cityFrom,
      to,
      selectedDays,
      aiSelected,
      starsSelected,
      usdSelected,
      selectedFlight,
    } = this.state;
    return {
      departureId: cityFrom.id,
      countryIds: to.id,
      days: selectedDays.days,
      aiSelected,
      fiveStarSelected: starsSelected,
      isUSD: usdSelected,
      onlyCharter: selectedFlight.id === 1,
      limit: 100,
    };
  };

  retrieveHots = (payload) => {
    this.setState({ isLoading: true });

    let finalPayload;
    if (payload) {
      finalPayload = payload;
    } else {
      finalPayload = this.getSearchPayload();
    }

    getHots(finalPayload)
      .then((response) => {
        if (response && response.data) {
          const { data } = response;

          this.setState({
            hots: this.formatTours(data, 4),
            hots3: this.formatTours(data, 3),
          });
        }
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  formatTours = (tours, itemsInLine) => {
    const formatted = [];

    if (tours.length > 0) {
      let line = [];
      let lineCounter = 0;

      for (let i = 0; i < tours.length; i++) {
        line.push(tours[i]);
        lineCounter++;

        if (lineCounter === itemsInLine || i === tours.length - 1) {
          formatted.push(line);

          line = [];
          lineCounter = 0;
        }
      }

      const lastLine = formatted[formatted.length - 1];
      if (lastLine.length < itemsInLine) {
        const needToAdd = itemsInLine - lastLine.length;

        for (let i = 0; i < needToAdd; i++) {
          lastLine.push({ emptyTour: true });
        }
      }
    }

    return formatted;
  };

  handleFromClick = () => {
    const { cityFromVisible } = this.state;
    if (!cityFromVisible) {
      document.addEventListener('click', this.handleFromOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleFromOutsideClick, false);
    }

    this.setState({ cityFromVisible: !cityFromVisible });
  };

  handleFromOutsideClick = (e) => {
    const { className } = e.target;
    if (
      (this.fromRef.current.contains(e.target) ||
        this.fromTRef.current.contains(e.target)) &&
      className !== 'hot_form_popup_but'
    ) {
      return;
    }

    this.handleFromClick();
  };

  renderFrom = () => {
    const result = [];
    for (let i = 0; i < CITY_OPTIONS.length; i++) {
      result.push(
        <button
          key={`city-${i}`}
          type="button"
          className="hot_form_popup_but"
          onClick={() => {
            this.setState({ cityFrom: CITY_OPTIONS[i] });
          }}
        >
          {CITY_OPTIONS[i].name}
        </button>,
      );
    }

    return result;
  };

  handleToClick = () => {
    const { toVisible } = this.state;
    if (!toVisible) {
      document.addEventListener('click', this.handleToOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleToOutsideClick, false);
    }

    this.setState({ toVisible: !toVisible });
  };

  handleToOutsideClick = (e) => {
    const { className } = e.target;

    if (
      (this.toRef.current.contains(e.target) ||
        this.toTRef.current.contains(e.target)) &&
      className !== 'hot_form_popup_but'
    ) {
      return;
    }

    this.handleToClick();
  };

  renderTo = () => {
    const { countryOpetions } = this.state;
    const result = [];

    for (let i = 0; i < countryOpetions.length; i++) {
      result.push(
        <button
          key={`country-${i}`}
          type="button"
          className="hot_form_popup_but"
          onClick={() => this.setState({ to: countryOpetions[i] })}
        >
          {countryOpetions[i].name}
        </button>,
      );
    }

    return result;
  };

  handleFlightClick = () => {
    const { flightVisible } = this.state;
    if (!flightVisible) {
      document.addEventListener('click', this.handleFlightOutsideClick, false);
    } else {
      document.removeEventListener(
        'click',
        this.handleFlightOutsideClick,
        false,
      );
    }

    this.setState({ flightVisible: !flightVisible });
  };

  handleFlightOutsideClick = (e) => {
    const { className } = e.target;

    if (
      (this.flightRef.current.contains(e.target) ||
        this.flightTRef.current.contains(e.target)) &&
      className !== 'hot_form_popup_but'
    ) {
      return;
    }

    this.handleFlightClick();
  };

  handlePeriodClick = () => {
    const { periodVisible } = this.state;
    if (!periodVisible) {
      document.addEventListener('click', this.handlePeriodOutsideClick, false);
    } else {
      document.removeEventListener(
        'click',
        this.handlePeriodOutsideClick,
        false,
      );
    }

    this.setState({ periodVisible: !periodVisible });
  };

  handlePeriodOutsideClick = (e) => {
    const { className } = e.target;

    if (
      (this.periodRef.current.contains(e.target) ||
        this.periodTRef.current.contains(e.target)) &&
      className !== 'hot_form_popup_but'
    ) {
      return;
    }

    this.handlePeriodClick();
  };

  renderHot = (hots) =>
    hots.map((tour, index) => (
      <div key={`hotsitem-${index}`} className="hot_item">
        {!tour.emptyTour && <HotsItem tour={tour} />}
      </div>
    ));

  renderToursLine = (toursLines) =>
    toursLines.map((toursLine, index) => (
      <div className="hot_line_w" key={`line-${index}`}>
        {this.renderHot(toursLine)}
      </div>
    ));

  scrollTo = (node) => {
    node.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  search = () => {
    const { cityFrom } = this.state;
    this.setState({ fromText: cityFrom.nameFrom });

    this.scrollTo(this.hotsSection);

    this.retrieveHots();
  };

  handleStarsFilter = () => {
    const { starsSelected } = this.state;
    this.setState({ starsSelected: !starsSelected });

    const payload = this.getSearchPayload();
    payload.fiveStarSelected = !starsSelected;

    this.retrieveHots(payload);
  };

  handleMealFilter = () => {
    const { aiSelected } = this.state;
    this.setState({ aiSelected: !aiSelected });

    const payload = this.getSearchPayload();
    payload.aiSelected = !aiSelected;

    this.retrieveHots(payload);
  };

  handleUSD = () => {
    const { usdSelected } = this.state;
    this.setState({ usdSelected: !usdSelected });

    const payload = this.getSearchPayload();
    payload.isUSD = !usdSelected;

    this.retrieveHots(payload);
  };

  isNotEmptyResult = () => {
    const { hots, isLoading } = this.state;

    return !isLoading && hots.length === 0;
  };

  render() {
    const {
      cityFromVisible,
      cityFrom,
      toVisible,
      flightVisible,
      periodVisible,
      to,
      selectedFlight,
      selectedDays,
      starsSelected,
      aiSelected,
      usdSelected,
      hots,
      hots3,
      isLoading,
      fromText,
    } = this.state;

    return (
      <div>
        <Helmet>
          <title>{HOT_TITLE}</title>
          <meta name="description" content={HOT_DESCRIPTION} />

          <meta property="og:site_name" content="TourHunter.by" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tourhunter.by/hot/" />
          <meta property="og:title" content={HOT_TITLE} />
          <meta property="og:description" content={HOT_DESCRIPTION} />
          <meta
            property="og:image"
            content="https://tourhunter.by/file/thr_logo.png"
          />

          <link rel="canonical" href="https://tourhunter.by/hot/" />
        </Helmet>

        <div>
          <div className="hot_hero">
            <div className="containerW">
              <div className="hot_title_w">
                <div className="hot_hero_title">{HOT_TOURS}</div>
                <Fire className="hot_fire" />
              </div>
              <div className="hot_form_w">
                <div className="hot_form">
                  <div className="hot_form_item" ref={this.fromRef}>
                    <button
                      type="button"
                      className="hot_form_button"
                      onClick={this.handleFromClick}
                    >
                      <div className="hot_buttom_inner">
                        <div className="br_text_14 opacity05 hot_form_item_title">
                          {HOT_FROM}
                        </div>
                        <div className="bm_text_18">{cityFrom.name}</div>
                      </div>
                    </button>
                    {cityFromVisible && (
                      <div className="hot_form_popup_w_scroll">
                        <div className="custom_scroll_container hot_to_options">
                          {this.renderFrom()}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="hot_form_item" ref={this.toRef}>
                    <button
                      type="button"
                      className="hot_form_button"
                      onClick={this.handleToClick}
                    >
                      <div className="hot_buttom_inner">
                        <div className="br_text_14 opacity05 hot_form_item_title">
                          {HOT_COUNTRY}
                        </div>
                        <div className="bm_text_18">{to.name}</div>
                      </div>
                    </button>
                    {toVisible && (
                      <div className="hot_form_popup_w_scroll">
                        <div className="custom_scroll_container hot_to_options">
                          {this.renderTo()}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="hot_form_item" ref={this.flightRef}>
                    <button
                      type="button"
                      className="hot_form_button"
                      onClick={this.handleFlightClick}
                    >
                      <div className="hot_buttom_inner">
                        <div className="br_text_14 opacity05 hot_form_item_title">
                          {HOT_FLIGHT}
                        </div>
                        <div className="bm_text_18">{selectedFlight.name}</div>
                      </div>
                    </button>
                    {flightVisible && (
                      <div className="hot_form_popup_w_scroll">
                        <div className="custom_scroll_container hot_to_options">
                          <button
                            type="button"
                            className="hot_form_popup_but"
                            onClick={() =>
                              this.setState({
                                selectedFlight: { id: 0, name: HOT_FLIGHT_ANY },
                              })
                            }
                          >
                            {HOT_FLIGHT_ANY}
                          </button>
                          <button
                            type="button"
                            className="hot_form_popup_but"
                            onClick={() =>
                              this.setState({
                                selectedFlight: {
                                  id: 1,
                                  name: HOT_FLIGHT_CHARTER,
                                },
                              })
                            }
                          >
                            {HOT_FLIGHT_CHARTER}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="hot_form_item" ref={this.periodRef}>
                    <button
                      type="button"
                      className="hot_form_button"
                      onClick={this.handlePeriodClick}
                    >
                      <div className="hot_buttom_inner">
                        <div className="br_text_14 opacity05 hot_form_item_title">
                          {HOT_PERIOD}
                        </div>
                        <div className="hot_form_sort_w">
                          <div className="bm_text_18">{selectedDays.name}</div>
                          <Arrow />
                        </div>
                      </div>
                    </button>
                    {periodVisible && (
                      <div className="hot_form_popup_w_scroll">
                        <div className="custom_scroll_container hot_to_options">
                          <button
                            type="button"
                            className="hot_form_popup_but"
                            onClick={() =>
                              this.setState({
                                selectedDays: {
                                  days: 21,
                                  name: HOT_PERIOD_ANY,
                                },
                              })
                            }
                          >
                            {HOT_PERIOD_ANY}
                          </button>
                          <button
                            type="button"
                            className="hot_form_popup_but"
                            onClick={() =>
                              this.setState({
                                selectedDays: { days: 3, name: HOT_PERIOD_3D },
                              })
                            }
                          >
                            {HOT_PERIOD_3D}
                          </button>
                          <button
                            type="button"
                            className="hot_form_popup_but"
                            onClick={() =>
                              this.setState({
                                selectedDays: { days: 7, name: HOT_PERIOD_1W },
                              })
                            }
                          >
                            {HOT_PERIOD_1W}
                          </button>
                          <button
                            type="button"
                            className="hot_form_popup_but"
                            onClick={() =>
                              this.setState({
                                selectedDays: { days: 21, name: HOT_PERIOD_1M },
                              })
                            }
                          >
                            {HOT_PERIOD_1M}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="hot_form_item">
                    <div className="hot_item_but">
                      <button
                        type="button"
                        className="sf_search_button bm_text_18"
                        onClick={this.search}
                        // disabled={isDisabled}
                      >
                        {HOT_SEARCH_TOUR}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="hot_form_t">
                  <div className="hot_form_t_line">
                    <div className="hot_form_t_item_left" ref={this.fromTRef}>
                      <button
                        type="button"
                        className="hot_from_t_button"
                        onClick={this.handleFromClick}
                      >
                        <div>
                          <div className="br_text_14 opacity05 hot_form_item_title">
                            {HOT_FROM}
                          </div>
                          <div className="hot_form_t_item_text_w">
                            <div className="bm_text_16">{cityFrom.name}</div>
                            <Arrow />
                          </div>
                        </div>
                      </button>
                      {cityFromVisible && (
                        <div className="hot_form_t_popup_w_scroll">
                          <div className="custom_scroll_container hot_to_options">
                            {this.renderFrom()}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="hot_form_t_item_right" ref={this.toTRef}>
                      <button
                        type="button"
                        className="hot_from_t_button"
                        onClick={this.handleToClick}
                      >
                        <div className="br_text_14 opacity05 hot_form_item_title">
                          {HOT_FROM}
                        </div>
                        <div className="hot_form_t_item_text_w">
                          <div className="bm_text_16">{to.name}</div>
                          <Arrow />
                        </div>
                      </button>
                      {toVisible && (
                        <div className="hot_form_t_popup_w_scroll">
                          <div className="custom_scroll_container hot_to_options">
                            {this.renderTo()}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="hot_form_t_line">
                    <div className="hot_form_t_item_left" ref={this.flightTRef}>
                      <button
                        type="button"
                        className="hot_from_t_button"
                        onClick={this.handleFlightClick}
                      >
                        <div className="br_text_14 opacity05 hot_form_item_title">
                          {HOT_FROM}
                        </div>
                        <div className="hot_form_t_item_text_w">
                          <div className="bm_text_16">
                            {selectedFlight.name}
                          </div>
                          <Arrow />
                        </div>
                      </button>
                      {flightVisible && (
                        <div className="hot_form_t_popup_w_scroll">
                          <div className="custom_scroll_container hot_to_options">
                            <button
                              type="button"
                              className="hot_form_popup_but"
                              onClick={() =>
                                this.setState({
                                  selectedFlight: {
                                    id: 0,
                                    name: HOT_FLIGHT_ANY,
                                  },
                                })
                              }
                            >
                              {HOT_FLIGHT_ANY}
                            </button>
                            <button
                              type="button"
                              className="hot_form_popup_but"
                              onClick={() =>
                                this.setState({
                                  selectedFlight: {
                                    id: 1,
                                    name: HOT_FLIGHT_CHARTER,
                                  },
                                })
                              }
                            >
                              {HOT_FLIGHT_CHARTER}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      className="hot_form_t_item_right"
                      ref={this.periodTRef}
                    >
                      <button
                        type="button"
                        className="hot_from_t_button"
                        onClick={this.handlePeriodClick}
                      >
                        <div className="br_text_14 opacity05 hot_form_item_title">
                          {HOT_PERIOD}
                        </div>
                        <div className="hot_form_t_item_text_w">
                          <div className="bm_text_16">{selectedDays.name}</div>
                          <Arrow />
                        </div>
                      </button>
                      {periodVisible && (
                        <div className="hot_form_t_popup_w_scroll">
                          <div className="custom_scroll_container hot_to_options">
                            <button
                              type="button"
                              className="hot_form_popup_but"
                              onClick={() =>
                                this.setState({
                                  selectedDays: {
                                    days: 0,
                                    name: HOT_PERIOD_ANY,
                                  },
                                })
                              }
                            >
                              {HOT_PERIOD_ANY}
                            </button>
                            <button
                              type="button"
                              className="hot_form_popup_but"
                              onClick={() =>
                                this.setState({
                                  selectedDays: {
                                    days: 3,
                                    name: HOT_PERIOD_3D,
                                  },
                                })
                              }
                            >
                              {HOT_PERIOD_3D}
                            </button>
                            <button
                              type="button"
                              className="hot_form_popup_but"
                              onClick={() =>
                                this.setState({
                                  selectedDays: {
                                    days: 7,
                                    name: HOT_PERIOD_1W,
                                  },
                                })
                              }
                            >
                              {HOT_PERIOD_1W}
                            </button>
                            <button
                              type="button"
                              className="hot_form_popup_but"
                              onClick={() =>
                                this.setState({
                                  selectedDays: {
                                    days: 31,
                                    name: HOT_PERIOD_1M,
                                  },
                                })
                              }
                            >
                              {HOT_PERIOD_1M}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <button
                    type="button"
                    className="hot_search_button bm_text_18"
                    onClick={this.search}
                  >
                    {HOT_SEARCH_TOUR}
                  </button>
                </div>
              </div>
              <div className="hot_teleg_w">
                <div className="hot_teleg">
                  <div className="hot_teleg_text">{HOT_TELEG}</div>
                  <Link
                    target="_blank"
                    to="https://t.me/tourhunterby"
                    className="hot_subscribe"
                  >
                    <Telegram />
                    <div className="hot_subscribe_text">{SUBSCRIBE}</div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="containerW">
              <div className="hot_from_title" ref={this.hotsSection}>
                {`${HOT_FROM_TITLE} ${fromText}`}
              </div>
              <div className="hot_filters_w">
                <button
                  type="button"
                  className={`hot_filter_item ${starsSelected ? 'hot_filter_item_selected' : ''}`}
                  onClick={this.handleStarsFilter}
                >
                  {HOT_5_STAR}
                </button>
                <button
                  type="button"
                  className={`hot_filter_item ${aiSelected ? 'hot_filter_item_selected' : ''}`}
                  onClick={this.handleMealFilter}
                >
                  {HOT_AI}
                </button>
                <button
                  type="button"
                  className={`hot_filter_item ${usdSelected ? 'hot_filter_item_selected' : ''}`}
                  onClick={this.handleUSD}
                >
                  {HOT_USD}
                </button>
              </div>
              <div>
                <div className="hot_items_w">
                  {isLoading
                    ? this.renderHotsLoaderLines(4)
                    : this.renderToursLine(hots)}
                </div>
                <div className="hot_t_items_w">
                  {isLoading
                    ? this.renderHotsLoaderLines(3)
                    : this.renderToursLine(hots3)}
                </div>
                {this.isNotEmptyResult() && (
                  <div className="hot_not_found_w">
                    <div className="hot_not_found">
                      <img src={NoResults} alt="" className="mb_5" />
                      <div className="br_text_18">{TOURS_NOT_FOUND}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="containerW">
            <div className="hot_seo">
              <h1 className="bm_text_32 mb_20">
                {`Горящие туры ${getCurrentYear()} — Туры last minute с экономией до 60% на
              онлайн-бронирование`}
              </h1>
              <p className="br_text_18 mb_10">
                Мечтаете об отдыхе, но не хотите переплачивать? Горящие туры —
                это ваш шанс улететь в отпуск мечты по цене вдвое ниже рыночной.
                Мы собрали лучшие предложения от туроператоров, которые снижают
                цены на нераспроданные места в самолетах и отелях. Не ждите
                понедельника — цены меняются каждые 15 минут. Забронируйте
                путевку онлайн за 5 минут прямо сейчас.
              </p>
              <p className="br_text_18 mb_10">
                Почему выгодно покупать горящие туры онлайн?
              </p>
              <p className="br_text_18 mb_10">
                Многие туристы ошибочно полагают, что «горящий» тур — это всегда
                что-то некачественное или «неликвид». Это не так. На нашем
                сервисе онлайн-бронирования представлены актуальные last minute
                туры от проверенных партнеров.
              </p>
              <p className="br_text_18 mb_10">
                Преимущества бронирования last minute:
              </p>
              <p className="br_text_18 mb_10">
                * Экономия бюджета. Скидки достигают 50-70% на пакетные туры
                (перелет + отель + трансфер). Туроператор снижает маржу, чтобы
                заполнить стыковку рейсов.
              </p>
              <p className="br_text_18 mb_10">
                * Мы работаем напрямую с системами бронирования. Вы видите
                реальную цену без наценок агентств.
              </p>
              <p className="br_text_18 mb_10">
                * Короткие сроки вылета. Вылеты от 2 до 14 дней. Идеально, если
                вы готовы сорваться в путешествие спонтанно.
              </p>
              <p className="br_text_18 mb_20">
                * Широкий выбор направлений. В категории «горящие туры»
                представлены как популярные пляжные курорты (Турция, Египет,
                ОАЭ), так и экскурсионные туры по Европе и Азии.
              </p>
              <h2 className="bm_text_26 mb_5">
                Популярные направления для last minute туров
              </h2>
              <p className="br_text_18 mb_10">
                Мы отслеживаем спрос в реальном времени. В данный момент
                максимальные скидки действуют на следующие направления:
              </p>
              <p className="br_text_18 mb_10">1. Горящие туры в Турцию</p>
              <p className="br_text_18 mb_10">
                Анталья, Аланья, Бодрум, Кемер. Все включено (Ultra All
                Inclusive) по цене завтраков. Отели снижают цены на оставшиеся
              </p>
              <p className="br_text_18 mb_10">2. Горящие туры в Египет</p>
              <p className="br_text_18 mb_10">
                Шарм-эль-Шейх, Хургада. Шарм без визы, Хургада виза по прилету.
                Идеально для спонтанного отдыха. Скидки достигают 40% на даты
                вылета «завтра/послезавтра».
              </p>
              <p className="br_text_18 mb_10">3. Горящие туры в ОАЭ</p>
              <p className="br_text_18 mb_10">
                Дубай, Шарджа. Роскошные отели с персональными пляжами по ценам
                прошлого сезона. Отличный вариант для шопинга и пляжного отдыха
                «все включено».
              </p>
              <p className="br_text_18 mb_10">
                4. Горящие туры в Грузию и Россию
              </p>
              <p className="br_text_18 mb_20">
                Для тех, кто не хочет тратить время на долгий перелет. Программы
                с перелетом и проживанием. Last minute предложения на выходные и
                праздничные дни.
              </p>

              <h2 className="bm_text_26 mb_5">Когда вылетать?</h2>
              <p className="br_text_18 mb_10">
                Мы рекомендуем ориентироваться на даты вылета. Чем ближе дата,
                тем выше скидка.
              </p>
              <p className="br_text_18 mb_10">
                * Вылет через 2-3 дня: Максимальная скидка, выбор ограничен, но
                цены минимальны. Отели могут не подтверждаться.
              </p>
              <p className="br_text_18 mb_10">
                * Вылет через 7-14 дней: Оптимальный баланс цены и выбора. Еще
                есть возможность оформить страховку от невылета и выбрать
                категорию номера.
              </p>
              <p className="br_text_18 mb_20">
                * Срочные туры (вылет завтра): Для самых авантюрных. Скидки «на
                грани рентабельности».
              </p>
              <h2 className="bm_text_26 mb_5">
                Часто задаваемые вопросы о горящих турах
              </h2>
              <p className="br_text_18 mb_10">
                Этот блок помогает закрыть возражения клиентов и ранжироваться
                по низкочастотным запросам.
              </p>
              <p className="br_text_18 mb_10">
                ❓ Что значит «горящий тур»? Это тур, срок вылета которого
                наступает в ближайшие 5-14 дней. Операторы снижают цену, чтобы
                покрыть расходы на чартерную программу. Тур «горит» не
                качеством, а сроком реализации.
              </p>
              <p className="br_text_18 mb_10">
                ❓ Нужна ли виза для горящего тура? Если вы выбираете Турцию,
                Китай, ОАЭ, Россию, Грузию — виза не нужна. Для стран Египет,
                Таиланд, Шри-Ланка можно оформить визу по прилету.
              </p>
              <p className="br_text_18 mb_20">
                ❓ Надежно ли бронировать онлайн в последний момент? Да. Наш
                сервис интегрирован с системами туроператоров. Вы получаете
                договор, чек и документы на вылет. Ваши права защищены
                законодательством.
              </p>
              <h2 className="bm_text_26 mb_5">Не упустите свою мечту!</h2>
              <p className="br_text_18 mb_30">
                Спонтанность — это лучший источник ярких эмоций. «Горящие» туры
                — это шанс позволить себе отдых премиум-класса по цене
                эконом-сегмента. Мы не храним устаревшие цены в базе. Все
                предложения на странице обновляются автоматически. Система
                показывает реальную цену с учетом всех акций туроператоров.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Hot;
